<template>
	<header
		class="absolute top-0 right-0 left-0 z-10 container flex flex-col items-center justify-between py-3 md:flex-row"
	>
		<div class="flex w-full items-center justify-between md:w-auto">
			<NuxtLink
				to="/"
				:class="dark ? 'text-white' : 'text-neutral-900 dark:text-neutral-100'"
				class="hover:text-brightGreen dark:hover:text-darkestGreen"
			>
				<!-- <img alt="Vue logo" class="h-auto w-16" src="/img/logo.svg" /> -->
				<span class="heading-font text-lg font-bold uppercase md:text-xl">
					Fürs Ehrenamt
				</span>
			</NuxtLink>
			<button
				data-collapse-toggle="navbar-default"
				type="button"
				class="hover:bg-brightestGreen/30 hover:text-brightGreen inline-flex items-center rounded-md p-2 focus:outline-hidden md:hidden"
				:class="
					dark
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				aria-controls="navbar-default"
				aria-expanded="false"
				@click="toggleMenu"
			>
				<UIcon name="i-heroicons-bars-2" class="size-6" />
			</button>
		</div>

		<nav
			id="navbar-default"
			class="mt-6 flex flex-col items-start justify-between self-start md:mt-0 md:flex-row md:space-x-2 md:self-center"
			:class="{
				hidden: itemsHidden,
				'absolute top-0 right-0 left-0 z-30 mx-3 mt-16! grow rounded-lg bg-white p-4 shadow-2xl dark:bg-neutral-800':
					isMobile,
			}"
		>
			<NuxtLink
				to="/"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="hideMenu"
			>
				Home
			</NuxtLink>

			<!-- Festival dropdown -->
			<!-- <div
				class="relative"
				@mouseover="handleMouseOver"
				@mouseleave="handleMouseLeave"
				@click.stop="showFestivalDropdown = !showFestivalDropdown"
			>
				<div
					class="flex cursor-pointer items-center rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
					:class="
						dark && !isMobile
							? 'text-white'
							: 'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'
					"
				>
					<span>Festival</span>
					<UIcon
						v-if="!isMobile"
						name="i-heroicons-chevron-up-down"
						class="ml-1 size-4 duration-150"
						:class="{
							'rotate-180': showFestivalDropdown,
						}"
					/>
					<UIcon
						v-else
						name="i-heroicons-chevron-up-down"
						class="ml-1 size-4 duration-150"
						:class="{
							'rotate-180': showFestivalDropdown,
						}"
					/>
				</div>

				<div
					v-if="!isMobile"
					v-show="showFestivalDropdown"
					class="absolute left-0 mt-2 w-40 origin-top-right rounded-md bg-white p-2 shadow-lg ring-1 ring-black ring-opacity-5 dark:bg-neutral-800"
					@mouseenter="cancelCloseTimeout"
					@mouseleave="delayedCloseDropdown"
				>
					<NuxtLink
						to="/openstage"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						Open Stage
					</NuxtLink>
					<NuxtLink
						to="/familientag"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						Familientag
					</NuxtLink>
					<NuxtLink
						to="/lineup"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						Line Up
					</NuxtLink>
					<NuxtLink
						to="/faqs"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						FAQs
					</NuxtLink>
				</div>

				<div v-if="isMobile && showFestivalDropdown" class="ml-4">
					<NuxtLink
						to="/openstage"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						Open Stage
					</NuxtLink>
					<NuxtLink
						to="/familientag"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						Familientag
					</NuxtLink>
					<NuxtLink
						to="/lineup"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						Line Up
					</NuxtLink>
					<NuxtLink
						to="/faqs"
						class="block rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
						:class="'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'"
						@click="hideMenu"
					>
						FAQs
					</NuxtLink>
				</div>
			</div> -->

			<!-- <NuxtLink
				v-if="!isAuthenticated"
				to="/ticket"
				class="rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'text-neutral-800 dark:text-neutral-200 dark:hover:text-darkestGreen'
				"
				@click="hideMenu"
			>
				Tickets
			</NuxtLink> -->
			<NuxtLink
				to="/impressionen"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="hideMenu"
			>
				Impressionen
			</NuxtLink>
			<NuxtLink
				to="/sponsoren"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="hideMenu"
			>
				Möglichmacher
			</NuxtLink>
			<!-- <NuxtLink
				to="/kulturstadel"
				class="rounded-md px-4 py-2 uppercase opacity-75 hover:bg-brightestGreen hover:text-darkestGreen hover:opacity-100"
				:class="dark && !isMobile ? 'text-white' : 'text-neutral-800  dark:text-neutral-200'"
				@click="hideMenu"
			>
				Kulturstadel
			</NuxtLink> -->
			<NuxtLink
				v-if="!isAuthenticated"
				to="/login"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="hideMenu"
			>
				Login
			</NuxtLink>
			<NuxtLink
				v-if="isAuthenticated && userStore.user?.role.id == 1"
				to="/admin"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="hideMenu"
			>
				Admin
			</NuxtLink>
			<NuxtLink
				v-if="isAuthenticated && userStore.user?.role.id == 2"
				to="/benutzer"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="hideMenu"
			>
				Mein Bereich
			</NuxtLink>
			<button
				v-if="isAuthenticated"
				class="hover:bg-brightestGreen hover:text-darkestGreen rounded-md px-4 py-2 uppercase opacity-75 hover:opacity-100"
				:class="
					dark && !isMobile
						? 'text-white'
						: 'dark:hover:text-darkestGreen text-neutral-800 dark:text-neutral-200'
				"
				@click="logout"
			>
				Ausloggen
			</button>
		</nav>
	</header>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		dark?: boolean
	}>(),
	{
		dark: false,
	}
)

const userStore = useUserStore()

const itemsHidden = ref(true)
const { isAuthenticated } = storeToRefs(userStore)
const isMobile = ref(false)
const showFestivalDropdown = ref(false)
const dropdownCloseTimeout = ref<number | null>(null)

const onWidthChange = () => {
	if (window.innerWidth > 768) {
		itemsHidden.value = false
		isMobile.value = false
	} else {
		itemsHidden.value = true
		isMobile.value = true
	}
}

onMounted(() => {
	window.addEventListener('resize', onWidthChange)

	onWidthChange()
})
onUnmounted(() => {
	window.removeEventListener('resize', onWidthChange)
	if (dropdownCloseTimeout.value) {
		clearTimeout(dropdownCloseTimeout.value)
	}
})

function toggleMenu() {
	itemsHidden.value = !itemsHidden.value
}

// Handle dropdown mouse events
function handleMouseOver() {
	if (isMobile.value) {
		return
	}
	cancelCloseTimeout()
	showFestivalDropdown.value = true
}

function handleMouseLeave() {
	if (isMobile.value) {
		return
	}
	delayedCloseDropdown()
}

// Close the dropdown after a page transition and if mobile close the menu
watch(
	() => useRoute().path,
	() => {
		if (isMobile.value) {
			itemsHidden.value = true
		}
		showFestivalDropdown.value = false
		cancelCloseTimeout()
	}
)

function delayedCloseDropdown() {
	// Clear any existing timeout first
	cancelCloseTimeout()

	// Set a new timeout for closing the dropdown
	dropdownCloseTimeout.value = window.setTimeout(() => {
		showFestivalDropdown.value = false
	}, 300) // 300ms delay before closing
}

function cancelCloseTimeout() {
	if (dropdownCloseTimeout.value !== null) {
		clearTimeout(dropdownCloseTimeout.value)
		dropdownCloseTimeout.value = null
	}
}

// Hides the menu after each click on a link
const hideMenu = () => {
	if (window.innerWidth < 768) {
		itemsHidden.value = true
	}
	showFestivalDropdown.value = false
	cancelCloseTimeout()
}

// Logout the user
async function logout() {
	userStore.logoutUser()
	await navigateTo('/login')
	// Hide Menu if necessary
	hideMenu()
}
</script>

<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
	transition:
		opacity 0.3s,
		transform 0.3s;
}

.dropdown-enter-from,
.dropdown-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}
</style>
